module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"due_date":"Due date","end_date":"End date","start_date":"Start date","to":"To"},"fr":{"due_date":"Date d\u0027échéance","end_date":"Date de fin","start_date":"Date de début","to":"à"},"de":{"due_date":"Geburtstermin","end_date":"Endtermin","start_date":"Startdatum","to":"Zu"}}')
  delete Component.options._Ctor
}
